import React, {useMemo} from 'react';
import VitalIcons from '../../../components/icons/VitalIcons';
import AlertBadge from './AlertBadge';
import styles from '../InpatientPortal.module.css';
import { formatValueByModalityId, getVitalUnit } from '../../../utils/unitUtils';
import { useSelector } from 'react-redux';


const VitalCard = ({ 
  vital,
  data,
  onClick,
  isSelected = false
}) => {

  const unitType = useSelector((state) => state.userInfo.unitType);

  const mostRecentMeasurement = useMemo(() => {
    if (vital.modalityId === 5 || vital.modalityId === 10) {
      const systolicData = data.filter(measurement => measurement.modalityId === 5);
      const diastolicData = data.filter(measurement => measurement.modalityId === 10);
      const systolic = systolicData.sort((a, b) => new Date(b.date) - new Date(a.date))[0]?.measurement;
      const diastolic = diastolicData.sort((a, b) => new Date(b.date) - new Date(a.date))[0]?.measurement;
      if (systolic !== undefined && diastolic !== undefined) {
        return `${systolic}/${diastolic} mmHg`;
      } else {
        return '--';
      }
    } else {
      const modalityData = data.filter(measurement => measurement.modalityId === vital.modalityId);
      const measurement = modalityData && modalityData.length > 0 ? modalityData.sort((a, b) => new Date(b.date) - new Date(a.date))[0] : null;
      
      if (measurement?.measurement !== null && measurement?.measurement !== undefined) {
        if (vital.modalityId === 7) {
          return 'Normal';
        }  else {
          return `${formatValueByModalityId(measurement.measurement, vital.modalityId)}${getVitalUnit(vital.modalityId, unitType)}`;
        }
      } 
    }
    return '--';
    
  }, [data, vital]);

        
  
  const getCardClassName = () => {
    let cardClass = styles.VitalCard;
    
    if (isSelected) {
      cardClass += ` ${styles.VitalCardActive}`;
    } else if (alert === "medium") {
      cardClass += ` ${styles.VitalCardAlertMedium}`;
    } else if (alert === "high") {
      cardClass += ` ${styles.VitalCardAlertHigh}`;
    }
    
    return `${cardClass}`;
  };

  const getTitleClassName = () => {
    let titleClass = styles.VitalCardTitle;
    
    if (isSelected) {
      titleClass += ` ${styles.VitalCardTitleActive}`;
    } else {
      titleClass += ` ${styles.VitalCardTitleDefault}`;
    }
    
    return titleClass;
  };

  return (
    <div 
      className={getCardClassName()}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <div className={styles.VitalCardLabel}>
        <VitalIcons 
          className={styles.VitalCardIcon}
          modalityId={vital.modalityId}
          size="36px"
        />
        <p className={getTitleClassName()}>
          {vital.title}
        </p>
      </div>
      <p className={styles.VitalCardValue}>
        {mostRecentMeasurement}
      </p>
      {/* {alert !== "None" && (
        <AlertBadge 
          status={alert}
          className={styles.VitalCardAlertBadge}
        />
      )} */}
    </div>
  );
};

export default VitalCard;
